export default [
  {
    path: 'topic',
    name: 'Topic',
    meta: {
      title: 'X实验室'
    },
    component: () =>
      import(
        '../views/exerland/topic/list.vue'
      )
  },
  {
    path: 'topicDetails/:id',
    name: 'TopicDetails',
    meta: {
      title: 'X实验室'
    },
    component: () =>
      import(
        '../views/exerland/topic/details.vue'
      )
  },
  {
    path: 'checkedTopic/:id',
    name: 'CheckedTopic',
    meta: {
      title: 'X实验室'
    },
    component: () =>
      import(
        '../views/exerland/topic/checkedOptions.vue'
      )
  }
]
